export var isOUIAEnvironment = function isOUIAEnvironment() {
  return typeof window !== 'undefined' && window.localStorage.ouia && window.localStorage.ouia.toLowerCase() === 'true' || false;
};
export var generateOUIAId = function generateOUIAId() {
  return typeof window !== 'undefined' && window.localStorage['ouia-generate-id'] && window.localStorage['ouia-generate-id'].toLowerCase() === 'true' || false;
};
var id = 0;
export var getUniqueId = function getUniqueId() {
  return id++;
};